<template>
	<div>
		<div class="d-flex align-items-center mb-3">
			<div>
				<h1 class="page-header mb-0"><i class="fa-solid fa-trash"></i> Törölt foglalások</h1>
			</div>
		</div>
		<div class="row">
			<div class="col-12">
				<panel title="Törölt foglalások">
					<Loading v-if="!bookings" title="Betöltés"></Loading>
					<NoRecords v-else-if="bookings.length == 0" main_icon="fa-solid fa-trash" value="false" title="Nincsenek foglalások"></NoRecords>
					<vue-good-table v-else
						:columns="columns" 
						:rows="bookings" 
						:search-options="{ enabled: false, placeholder: 'Keresés...' }" 
						:pagination-options="{
							enabled: true, 
							position: 'bottom',

						}"
					>
						<template slot="table-row" slot-scope="props">
							<span v-if="props.column.field == 'actions'">
								<button @click="confirmRestore(props.row.id)" class="btn btn-success btn-sm mx-1" title="visszaállítás"><i class="fa fa-eye"></i></button>
							</span>
							<span v-else>
								{{props.formattedRow[props.column.field]}}
							</span>
						</template>
					</vue-good-table>
				</panel>
			</div>
		</div>		
	</div> 
</template>

<script>
	import Booking from "../../apis/Booking";
	import Confirmation from "../../apis/Confirmation"; 

	export default {
		data() {
			return {
				columns: [
					{
						label: 'Azonosító',
						field: 'id'
					},
					{
						label: 'Név',
						field: 'name',
						filterOptions : {
							enabled:true,
							placeholder: 'Keresés',
						}
					},
					{
						label: 'Vendégház',
						field: 'guesthouse_name',
						filterOptions : {
							enabled:true,
							placeholder: 'Keresés',
						}
					},
					{
						label: 'Szobák',
						field: 'rooms',
					},
					{
						label: 'Fizetendő',
						field: 'price'
					},
					{
						label: 'Érkezés - távozás',
						field: 'interval'
					},
					{
						label: 'Actions',
						field: 'actions',
						width: '15%',
						sortable: false,
						thClass: 'text-end',
						tdClass: 'text-end',
					}  
				],
				bookings: false,
				loading: false,
				errors:[]
			}
		},
		created() {
			Booking.deleted()
			.then(response => {
				this.bookings = response.data;
			});
		},
		methods: {
			confirmRestore(id){
				Confirmation.swalRestore().then(response => {
					if(response.isConfirmed === true){
						this.restoreBooking(id);
					}
				})
			},
			restoreBooking(id) {
				Booking.restore(id)
					.then(() => {
						this.bookings.splice(this.bookings.map(n => n.id).indexOf(id),1);
					})
			},
		},
	}
</script>

<style>
	
</style>